// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ppp-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  padding-top: 0;
}
.ppp-wrapper .head-wrapper {
  width: 100%;
  max-width: 1440px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 32px;
}
.ppp-wrapper .head-wrapper > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-end;
}
.ppp-wrapper .head-wrapper > div span:first-child {
  font-size: clamp(0.75rem, 0.6453rem + 0.3941vw, 1rem);
  font-weight: 400;
  color: #7a7a7a;
}
.ppp-wrapper .head-wrapper > div span:last-child {
  font-size: clamp(0.625rem, 0.5727rem + 0.197vw, 0.75rem);
  font-weight: 400;
  color: #7a7a7a;
}
.ppp-wrapper .back-button-wrapper {
  width: 100%;
  max-width: 1440px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 26px;
  margin-bottom: 32px;
}
.ppp-wrapper .back-button-wrapper span,
.ppp-wrapper .back-button-wrapper svg {
  cursor: pointer;
}
.ppp-wrapper .body-wrapper {
  width: 100%;
  max-width: 1440px;
  display: flex;
  gap: 16px;
}
.ppp-wrapper .body-wrapper .left-body-wrapper {
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .status-body-wrapper {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 20px;
  display: inline-block;
  width: 100%;
  text-align: left;
  font-size: 18px;
  font-weight: 500;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .quotation-expired-wrapper {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 20px;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .quotation-expired-wrapper span {
  display: inline-block;
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .nri-checkbox-wrapper {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 20px;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .nri-checkbox-wrapper .nri-checkbox {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  width: fit-content;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .nri-checkbox-wrapper .nri-checkbox input {
  display: none;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .nri-checkbox-wrapper .nri-checkbox .tick-mark {
  position: absolute;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 2px solid #aaa;
  border-radius: 3px;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .nri-checkbox-wrapper .nri-checkbox input:checked + .tick-mark {
  background-color: #fff;
  border-color: #93288E;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .nri-checkbox-wrapper .nri-checkbox .tick-mark:after {
  content: "";
  position: absolute;
  display: none;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .nri-checkbox-wrapper .nri-checkbox input:checked + .tick-mark:after {
  display: block;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .nri-checkbox-wrapper .nri-checkbox .tick-mark:after {
  left: 5px;
  top: 0px;
  width: 7px;
  height: 12px;
  border: solid #93288E;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.ppp-wrapper .body-wrapper .left-body-wrapper .nri-checkbox-wrapper .nri-checkbox .label-text {
  margin-left: 32px;
  font-size: 20px;
  font-weight: 500;
  color: #7a7a7a;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .nri-checkbox-wrapper .nri-checkbox .label-text.active {
  color: #000;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .nri-checkbox-wrapper .agree-tcs-text {
  font-size: 15px;
  font-weight: 400;
  font-style: italic;
  color: #7a7a7a;
  margin: 4px 0 0 32px;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .nri-checkbox-wrapper .agree-tcs-text.active {
  color: #000;
}
.ppp-wrapper .body-wrapper .left-body-wrapper .nri-checkbox-wrapper .agree-tcs-text.active span {
  font-weight: 700;
  color: #93288E;
}
.ppp-wrapper .body-wrapper .right-body-wrapper {
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ppp-wrapper .body-wrapper .right-body-wrapper .payment-button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 0;
  background: #93288E;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 22px;
  font-weight: 700;
  cursor: pointer;
}
.ppp-wrapper .body-wrapper .right-body-wrapper .payment-button.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media only screen and (width <= 768px) {
  .ppp-wrapper .body-wrapper {
    flex-direction: column;
  }
  .ppp-wrapper .body-wrapper .left-body-wrapper,
  .ppp-wrapper .body-wrapper .right-body-wrapper {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPaymentPage/style.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AACJ;AACI;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AACR;AACQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,qBAAA;AACZ;AACY;EACI,qDAAA;EACA,gBAAA;EACA,cAAA;AAChB;AAEY;EACI,wDAAA;EACA,gBAAA;EACA,cAAA;AAAhB;AAKI;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AAHR;AAKQ;;EAEI,eAAA;AAHZ;AAOI;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;AALR;AAOQ;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AALZ;AAOY;EACI,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AALhB;AAQY;EACI,sBAAA;EACA,kBAAA;EACA,aAAA;AANhB;AAQgB;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AANpB;AAUY;EACI,sBAAA;EACA,kBAAA;EACA,aAAA;AARhB;AAUgB;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AARpB;AAUoB;EACI,aAAA;AARxB;AAWoB;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AATxB;AAYoB;EACI,sBAAA;EACA,qBAAA;AAVxB;AAaoB;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AAXxB;AAcoB;EACI,cAAA;AAZxB;AAeoB;EACI,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;AAbxB;AAgBoB;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAdxB;AAgBwB;EACI,WAAA;AAd5B;AAmBgB;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;AAjBpB;AAmBoB;EACI,WAAA;AAjBxB;AAkBwB;EACI,gBAAA;EACA,cAAA;AAhB5B;AAwBQ;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAtBZ;AAwBY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAtBhB;AAwBgB;EACI,YAAA;EACA,mBAAA;AAtBpB;;AA6BA;EAGQ;IACI,sBAAA;EA5BV;EA8BU;;IAEI,WAAA;EA5Bd;AACF","sourcesContent":[".ppp-wrapper {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 10px;\n    padding-top: 0;\n\n    .head-wrapper {\n        width: 100%;\n        max-width: 1440px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        gap: 12px;\n        padding-top: 10px;\n        padding-bottom: 10px;\n        margin-bottom: 32px;\n\n        >div{\n            display: flex;\n            flex-direction: column;\n            gap: 2px;\n            align-items: flex-end;\n\n            span:first-child {\n                font-size: clamp(0.75rem, 0.6453rem + 0.3941vw, 1rem);\n                font-weight: 400;\n                color: #7a7a7a;\n            }\n\n            span:last-child{\n                font-size: clamp(0.625rem, 0.5727rem + 0.197vw, 0.75rem);\n                font-weight: 400;\n                color: #7a7a7a;\n            }\n        }\n    }\n\n    .back-button-wrapper {\n        width: 100%;\n        max-width: 1440px;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        margin-top: 26px;\n        margin-bottom: 32px;\n\n        span,\n        svg {\n            cursor: pointer;\n        }\n    }\n\n    .body-wrapper {\n        width: 100%;\n        max-width: 1440px;\n        display: flex;\n        gap: 16px;\n\n        .left-body-wrapper {\n            width: 60%;\n            display: flex;\n            flex-direction: column;\n            gap: 16px;\n\n            .status-body-wrapper{\n                border: 1px solid #ddd;\n                border-radius: 6px;\n                padding: 20px;\n                display: inline-block;\n                width: 100%;\n                text-align: left;\n                font-size: 18px;\n                font-weight: 500;\n            }\n\n            .quotation-expired-wrapper{\n                border: 1px solid #ddd;\n                border-radius: 6px;\n                padding: 20px;\n                \n                span{\n                    display: inline-block;\n                    width: 100%;\n                    text-align: center;\n                    font-size: 20px;\n                    font-weight: 500;\n                }\n            }\n\n            .nri-checkbox-wrapper {\n                border: 1px solid #ddd;\n                border-radius: 6px;\n                padding: 20px;\n                \n                .nri-checkbox {\n                    display: flex;\n                    align-items: center;\n                    position: relative;\n                    cursor: pointer;\n                    width: fit-content;\n\n                    input {\n                        display: none;\n                    }\n\n                    .tick-mark {\n                        position: absolute;\n                        height: 20px;\n                        width: 20px;\n                        background-color: #fff;\n                        border: 2px solid #aaa;\n                        border-radius: 3px;\n                    }\n\n                    input:checked+.tick-mark {\n                        background-color: #fff;\n                        border-color: #93288E;\n                    }\n\n                    .tick-mark:after {\n                        content: \"\";\n                        position: absolute;\n                        display: none;\n                    }\n\n                    input:checked+.tick-mark:after {\n                        display: block;\n                    }\n\n                    .tick-mark:after {\n                        left: 5px;\n                        top: 0px;\n                        width: 7px;\n                        height: 12px;\n                        border: solid #93288E;\n                        border-width: 0 2px 2px 0;\n                        transform: rotate(45deg);\n                    }\n\n                    .label-text {\n                        margin-left: 32px;\n                        font-size: 20px;\n                        font-weight: 500;\n                        color: #7a7a7a;\n\n                        &.active {\n                            color: #000;\n                        }\n                    }\n                }\n\n                .agree-tcs-text{\n                    font-size: 15px;\n                    font-weight: 400;\n                    font-style: italic;\n                    color: #7a7a7a;\n                    margin: 4px 0 0 32px;\n\n                    &.active{\n                        color: #000;\n                        span{\n                            font-weight: 700;\n                            color: #93288E;\n                        }\n                    }\n                }\n            }\n\n        }\n\n        .right-body-wrapper {\n            width: 40%;\n            display: flex;\n            flex-direction: column;\n            gap: 16px;\n\n            .payment-button {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                gap: 12px;\n                width: 100%;\n                padding: 10px 0;\n                background: #93288E;\n                color: #fff;\n                border: none;\n                border-radius: 5px;\n                font-size: 22px;\n                font-weight: 700;\n                cursor: pointer;\n\n                &.disabled {\n                    opacity: 0.6;\n                    cursor: not-allowed;\n                }\n            }\n        }\n    }\n}\n\n@media only screen and (width <=768px) {\n    .ppp-wrapper {\n\n        .body-wrapper {\n            flex-direction: column;\n\n            .left-body-wrapper,\n            .right-body-wrapper {\n                width: 100%;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
